<template>
	<template-base class="containerCard">
		<div>
			<div v-if="customers.length && !showPaginationOnlyFooter" class="head-row mb-2 width-pagination-items">
				<div class="text-head-row width-pagination">
					<label class="text-head-row ml-0">
						Resultado {{ pagination.offset + 1 }}-{{ pagination.offset + customers.length }} de {{ pagination.count }}
					</label>
					<b-pagination
						class="mr-0 mb-2"
						id="page"
						v-model="currentPage"
						:total-rows="pagination.count"
						:per-page="pagination.limit.value"
					></b-pagination>
				</div>
				<b-form
					class="text-head-row width-pagination">
					<label class="text-head-row ml-0">
						Itens por página
					</label>
					<b-form-select
						class="mr-0 mb-2"
						v-model="pagination.limit.value"
						name="itens-por-pagina"
						:options="optionsItensPorPag"
						@input="changeItensByPage()"
						:disabled="loading"
					/>
				</b-form>
			</div>
		</div>
		<EditCustomer
			v-if="modalEdit"
			:customerData="customerSelected"
			@closeModal="closeModal"
			@findCustomer="findCustomer"
		/>
		<div>
			<DataTable v-if="!isMobile"
				class="data-table"
				:loading="loading"
				:colunas="colunas"
				:linhas="linhas"
				:errMsg="errMsg"
				:nofilters="true"
				name="clientes"
				:hasPagination="true"
				:noedit="true"
				:acoes="true"
				:permissaoEdit="possuiPermissao('GER_U_CUSTOMER')"
				:permissaoDelete="possuiPermissao('GER_D_CUSTOMER')"
				@clickDelete="confirmaApagar"
				@clickEdit="mostrarEdicao"
				@clickSortTableBy="(v) => sortTableBy(v)"
				:state="{
					sortBy: sortTable.sortBy,
					sortAsc: sortTable.order === 1,
					query: ''
				}"
				:async="true"
				@state-change="(state) => newSearch(state)"
				@clickBtnAdd="mostrarEdicao"
				:nosearch="false"
				:hideBtnAdd="!possuiPermissao('GER_I_CUSTOMER')"
			/>
			<CardTransaction v-else
				:loading="loading"
				:colunas="colunas"
				:linhas="linhas"
				:errMsg="errMsg"
				:acoes="true"
				:permissaoEdit="possuiPermissao('GER_U_CUSTOMER')"
				:permissaoDelete="possuiPermissao('GER_D_CUSTOMER')"
				@clickDelete="confirmaApagar"
				@clickEdit="mostrarEdicao"
				:selectItem="false"
				:globalAcoes="false"
				:colsDataCard="colsDataCard"
				:details="false"
				:showSelectItem="false"
				@state-change="(state) => newSearch(state)"
				@clickBtnAdd="mostrarEdicao"
				:nosearch="false"
				:hideBtnAdd="!possuiPermissao('GER_I_CUSTOMER')"
			/>
		</div>
		<div v-if="customers.length && showPaginationOnlyFooter" class="text-head-row d-block">
			<section style="display: flex; justify-content: center;">
				<b-pagination
					id="page"
					class="mb-1"
					v-model="currentPage"
					:total-rows="pagination.count"
					:per-page="pagination.limit.value"
				></b-pagination>
			</section>
			<section style="display: flex; justify-content: center;">
				<label class="text-head-row" style="width: auto;">
					Resultado {{ pagination.offset + 1 }}-{{ pagination.offset + linhas.length }} de {{ pagination.count }}
				</label>
			</section>
		</div>
	</template-base>
</template>

<script>
	import DataTable from "@/components/DataTable";
	import TemplateBase from "@/templates/Base";

	import { possuiPermissao } from "../../helpers/permissions";
	import { CustomerService } from "../../services/customer";
	import { hasFieldsWithErrors } from "@/helpers/validators";
	import { formatIdentityDocument } from "@/helpers/validateIndentity";
	import CardTransaction from "@/components/CardTransaction.vue";
	import emitter from "@/eventBus.js";
	import EditCustomer from "./EditCustomer.vue";

	export default {
		components: {
			TemplateBase,
			DataTable,
			CardTransaction,
			EditCustomer
		},

		inject: ["parentValidator"],

		data () {
			return {
				modalEdit: false,
				customers: [],
				linhas: [],
				loading: true,
				customerSelected: {},

				customerService: new CustomerService(),

				errMsg: "Nenhum cliente cadastrado!",
				colunas: [
					"CPF/CNPJ",
					"Nome",
					"Sobrenome",
					"E-mail",
					"Celular",
					"Telefone"
				],
				pagination: {
					count: 0,
					page: 1,
					offset: 0,
					limit: {
						value: 50
					},
					pages: 1
				},
				currentPage: 1,
				optionsItensPorPag: [
					{
						value: 5,
						text: "5 Items"
					},
					{
						value: 25,
						text: "25 Items"
					},
					{
						value: 50,
						text: "50 Items"
					},
					{
						value: 75,
						text: "75 Items"
					},
					{
						value: 100,
						text: "100 Items"
					}
				],
				possuiPermissao,
				sortTable: {
					sortBy: 1,
					order: 1,
					query: ""
				},
				formatIdentityDocument,
				isMobile: false,
				colsDataCard: {
					0: {
						idx: 1,
						label: "Nome",
						textAlign: "left",
						cols: 6,
						visible: true
					},
					1: {
						idx: 2,
						label: "Sobrenome",
						textAlign: "left",
						cols: 6,
						visible: true
					},
					2: {
						idx: 0,
						label: "CPF/CNPJ",
						textAlign: "left",
						cols: 3,
						visible: true
					},
					3: {
						idx: 3,
						label: "E-mail",
						textAlign: "left",
						cols: 3,
						visible: true
					},
					4: {
						idx: 4,
						label: "Celular",
						textAlign: "left",
						cols: 3,
						visible: true
					},
					5: {
						idx: 5,
						label: "Telefone",
						textAlign: "left",
						cols: 3,
						visible: true
					},
					6: {
						idx: null,
						label: "",
						textAlign: "left",
						cols: 12,
						visible: false
					},
					7: {
						idx: null,
						label: "",
						textAlign: "",
						cols: 0,
						visible: false
					}
				},
				showPaginationOnlyFooter: true
			};
		},

		watch: {
			currentPage () {
				this.changePage(this.currentPage);
			}
		},

		created () {
			this.$validator = this.parentValidator;
		},

		async mounted () {
			this.checkIfMobile();
			window.addEventListener("resize", this.checkIfMobile);

			this.findCustomer();
		},

		beforeDestroy () {
			window.removeEventListener("resize", this.checkIfMobile);
		},

		methods: {
			checkIfMobile	() {
				this.isMobile = window.innerWidth <= 768;
			},

			sortTableBy (v) {
				this.sortTable = v;
				this.findCustomer();
			},

			changePage () {
				this.pagination.page = this.currentPage;
				this.findCustomer();
			},

			changeItensByPage () {
				this.pagination.page = 1;
				this.findCustomer();
			},

			async findCustomer () {
				this.loading = true;
				const limit = this.pagination.limit.value;
				this.pagination.offset = (this.pagination.page - 1) * limit;
				const offset = this.pagination.offset;
				const sortTable = this.sortTable;
				const result = await this.customerService.listCustomer({ offset, limit, sortTable }) || {};
				this.customers = result.rows || [];

				this.linhas = result.rows.reduce((acc, customer) => [
					...acc,
					{
						idCustomer: customer.idCustomer,
						cols: [
							customer.identityDocument ? formatIdentityDocument(customer.identityDocument) : "",
							customer.name,
							customer.surname,
							customer.email,
							customer.cellPhone,
							customer.telephone
						]
					}
				], []);
				this.pagination.count = result.count || 0;
				this.pagination.pages = this.pagination.count > limit ? Math.ceil(this.pagination.count / limit) : 1;
				this.loading = false;
			},

			mostrarEdicao (item_) {
				let item = {};
				if (item_.idCustomer)
					[ item ] = this.customers.filter((customer) => customer.idCustomer === item_.idCustomer);

				this.customerSelected = item;
				this.modalEdit = true;
			},

			async confirmaApagar (item_) {
				const [ item ] = this.customers.filter((customer) => customer.idCustomer === item_.idCustomer);
				const deleteConfirmation = (await this.$swal({
					title: "Excluir",
					text: "Tem certeza que deseja remover o cliente?",
					type: "error",
					showCancelButton: true,
					cancelButtonColor: "#A6A8AB",
					confirmButtonColor: "#DD6B55",
					imageWidth: 50,
					imageHeight: 50,
					cancelButtonText: "Não",
					confirmButtonText: "Sim",
					reverseButtons: true
				})).value;

				if (deleteConfirmation)
					this.apagar(item.idCustomer);
			},

			async apagar (idCustomer) {
				const config = {
					timeout: 2000,
					showProgressBar: true,
					closeOnClick: true,
					pauseOnHover: true
				};

				this.$snotify.async("Aguarde...", "Apagando", async () => {
					try {
						await this.customerService.deleteCustomer({ idCustomer });
						this.findCustomer();
						emitter.emit("reloadCustomer", { reload: true });

						return {
							title: "Sucesso!",
							body: "Usuário deletado com sucesso.",
							config
						};
					} catch (error) {
						const msgError = error.response.data.message || "Erro ao tentar deletar o cliente!";
						throw {
							title: "Falha!",
							body: msgError,
							config
						};
					}
				});
			},

			newSearch (state) {
				this.sortTable.query = state.query;
				this.findCustomer();
			},

			closeModal () {
				this.modalEdit = false;
			}
		}
	};
</script>

<style scoped>
	.table-th-funcionalidade {
		font-family: "Roboto Condensed Medium";
		letter-spacing: -0.05em;
		font-size: 20px;
	}

	.table-td-funcionalidade {
		font-family: "Roboto Condensed Regular";
		letter-spacing: -0.05em;
		font-size: 16px;
	}

	label {
		width: 160px;
	}

	.container-head {
		display: flex;
		height: 5rem;
		width: 100%;
	}

	.container-pages {
		display: flex;
		width: 70%;
		margin-top: 1.5rem;
	}

	.containerCard {
		max-width: 90.5%;
	}

	.modal-edicao-label {
		font-family: "Roboto Condensed Regular";
		font-size: 23px;
		letter-spacing: -0.05em;
	}

	.modal-edicao-input {
		font-family: "Roboto Condensed Regular";
		font-size: 20px;
		letter-spacing: -0.05em;
	}

	.table-body-detalhe {
		padding: 5px 0;
	}

	.container-add-new-100 {
		width: 100% !important;
	}
</style>

<style>
	.form-control {
		height: auto !important;
	}
</style>
